import {FC} from 'react'
import {Link} from 'react-router-dom'
import {SubmitHandler, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import Button from 'jbc-front/components/Button'
import {Label} from 'jbc-front/components/presenters/form/Label'
import {Textarea} from 'jbc-front/components/presenters/form/Textarea'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import {EmployeeName} from '../../parts/EmployeeName'
import {Employee} from './query'
import {Schema, schema} from './schema'
import styles from './Presenter.scss'

interface PresenterParams {
  employee: Employee
  onSubmit: SubmitHandler<Schema>
  onSkip: SubmitHandler<Schema>
}

export const Presenter: FC<PresenterParams> = ({employee, onSubmit, onSkip}) => {
  const {
    register,
    handleSubmit,
    formState: {isSubmitting, errors},
  } = useForm<Schema>({
    defaultValues: {
      message: '',
    },
    resolver: yupResolver(schema),
  })

  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">以下の情報を従業員に入力依頼できます</h1>
        <EmployeeName employee={employee} />
      </div>
      <div className="l-wrap-s">
        <div className={styles.box}>
          <ul className={styles.list}>
            <li>
              健康保険・厚生年金保険 育児休業等取得者申出書（新規・延長）／終了届
              <ul className={styles.subList}>
                <li>養育する子の氏名</li>
                <li>養育する子の生年月日</li>
                <li>区分</li>
                <li>養育開始年月日（実子以外）</li>
                <li>育児休業等開始年月日</li>
                <li>育児休業等終了（予定）年月日</li>
                <li>育児休業等取得日数</li>
                <li>就業予定日数</li>
                <li>パパママ育休プラス該当区分</li>
                <li>備考</li>
                <li>B.終了 育児休業等終了年月日</li>
                <li>B.終了 変更後の育児休業等取得日数</li>
                <li>育休等取得内訳</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className={styles.formWrap}>
          <Label>メッセージ</Label>
          <Spacer direction="y" size={10} />
          <Textarea
            {...register('message')}
            isError={!!errors.message?.message}
            placeholder="入力したメッセージは送信メールに反映されます"
          />
          {errors.message?.message && <ErrorMessage>{errors.message.message}</ErrorMessage>}
          <Spacer direction="y" size={20} />

          <div className={styles.buttonWrap}>
            <Button onClick={handleSubmit(onSkip)} disabled={isSubmitting}>
              スキップ
            </Button>
            <div className={styles.buttonNoteWrap}>
              <Button
                primary
                onClick={handleSubmit(onSubmit)}
                disabled={isSubmitting || !employee.user || !employee.user.email}
                className="u-ml20"
              >
                上記の入力依頼を送信
              </Button>
              {(!employee.user || !employee.user.email) && (
                <div className={styles.noteWrap}>
                  <div className={styles.note}>
                    <p>
                      従業員に手続きの入力依頼をする場合、あらかじめ従業員招待をしてマイページを発行してください。従業員招待は
                      <Link to="/employees/invite">こちら</Link>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
